'use client'
import React from 'react'
import 'react-loading-skeleton/dist/skeleton.css'
import { Loader } from '@umahealth/occipital'

export default function LoadingHome(){
	return (
		<div className='h-full grid place-content-center justify-center h gap-4'>
			<Loader className='m-auto' size='size-7' color='stroke-primary' />
		</div>
	)
}